/**
 * Caller gate for admin actions. Every admin Lambda re-reads the caller's
 * Users row on each request and checks it here: a Cognito token minted before
 * a Provider Owner was deactivated (or demoted) stays valid for up to an hour,
 * so the token alone never authorises an admin action.
 */
import { isInactiveUserStatus } from '../users/deactivated-user'
import { isL4ProviderOwner, type RoleProfile } from './member-roles'

export type AccountStateRow = {
  status?: string | null
  archivedAt?: string | null
  deletedAt?: string | null
}

/** Not deactivated (status `inactive` / archived) and not deleted. */
export function isLiveAccount(row: AccountStateRow): boolean {
  return !isInactiveUserStatus(row.status) && !row.archivedAt && !row.deletedAt
}

/** A Provider Owner (L4) whose account is live right now. */
export function isActiveProviderOwner(
  row: (RoleProfile & AccountStateRow) | null | undefined,
): boolean {
  return Boolean(row && isLiveAccount(row) && isL4ProviderOwner(row))
}
